import React, { useEffect, useState } from "react";
import { Grid, Stack, TextField, Typography } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCarTwoTone";
import { useUpdateLenderArrayFieldsMutation } from "../../../../store/slices/apiSlice";

const DisclaimerSection = React.memo(({ lender }) => {
  const [updateLenderArrayFields] = useUpdateLenderArrayFieldsMutation();
  const [disclaimer, setDisclaimer] = useState(lender.disclaimer);

  useEffect(() => {
    setDisclaimer(lender.disclaimer);
  }, [lender.disclaimer]);

  const lenderId = lender?._id;

  const handle = {
    editDisclaimer: async (e) => {
      const updatedDisclaimer = e.target.value;
      setDisclaimer(updatedDisclaimer);
      if (updatedDisclaimer !== lender.disclaimer) {
        await updateLenderArrayFields({ lenderId, disclaimer: updatedDisclaimer });
      }
    },
    onChangeDisclaimer: (e) => {
      setDisclaimer(e.target.value);
    }
  };

  return (
    <Grid
      container
      xs={12}
      style={{
        margin: "0 0 30px",
        padding: "0 0 20px",
        borderBottom: "1px solid rgba(0,0,0,0.12)",
      }}
    >
      <Grid container xs={3} alignItems="start" direction="column">
        <Stack direction="row" style={{ marginBottom: "10px" }}>
          <DirectionsCarIcon style={{ marginRight: "10px" }} />
          <Typography>Disclaimer</Typography>
        </Stack>
      </Grid>
      <Grid
        container
        xs={9}
        spacing={2}
        alignContent={"center"}
      >
        <Grid
          container
          item
          spacing={1}
          xs={9}
          direction="column"
          style={{ margin: "0px 0px 7px 0px" }}
          rowGap={"16px"}
        >
          <Stack direction={"row"} alignItems={"center"} gap={"16px"}>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={disclaimer}
              label={`Disclaimer`}
              onChange={handle.onChangeDisclaimer}
              onBlur={handle.editDisclaimer}
            />
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default DisclaimerSection;
